import React, {
    useContext, useEffect, useRef, useState
} from 'react';
import ForceChangePasswordForm from './ForceChangePasswordForm';
import {
    Context
} from 'shared/context/GlobalState';
import {
    authService
} from 'shared/api';

export default function ForceChangePassword() {
    const [loading, setLoading] = useState(false);
    const formRef = useRef(null);
    const {
        addNewNotifcation
    } = useContext(Context);

    const email = sessionStorage.getItem('password-expiry-email');

    useEffect(() => {
        if (!email) {
            window.location = '/auth/login';
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        const currentPassword = formRef.current.getCurrentPasswordRef().value;
        const newPassword = formRef.current.getNewPasswordRef().value;
        const confirmPassword = formRef.current.getConfirmPasswordRef().value;

        if (newPassword !== confirmPassword) {
            return addNewNotifcation('Passwords do not match. Please enter the same password for confirmation.', 'danger');
        }

        if (newPassword.length < 8) {
            return addNewNotifcation('New password must be at least 8 characters.', 'danger');
        }

        setLoading(true);
        authService.updateExpiredPassword({
            email,
            oldPassword: currentPassword,
            newPassword,
        })
            .then(() => {
                sessionStorage.removeItem('password-expiry-email');
                addNewNotifcation('Password changed successfully. Please log in with your new password.', 'success');
                setTimeout(() => {
                    window.location = '/auth/login';
                }, 1500);
            })
            .catch((error) => {
                if (error.response?.status === 403) {
                    addNewNotifcation('Current password is incorrect.', 'danger');
                } else if (error.response?.data?.message) {
                    addNewNotifcation(error.response.data.message, 'danger');
                } else {
                    addNewNotifcation('Something went wrong. Please try again.', 'danger');
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    if (!email) return null;

    return (
        <div className='flex flex-grow flex-col justify-center items-center'>
            <ForceChangePasswordForm ref={formRef} loading={loading} onSubmit={handleSubmit} />
        </div>
    );
}
